import { render, staticRenderFns } from "./FullArticleView.vue?vue&type=template&id=3496f1bb"
import script from "./FullArticleView.vue?vue&type=script&lang=js"
export * from "./FullArticleView.vue?vue&type=script&lang=js"
import style0 from "./FullArticleView.vue?vue&type=style&index=0&id=3496f1bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports